import React from 'react';
import Button from '@atlaskit/button';
import type {
	IntlShapeV2 as IntlShape,
	MessageDescriptorV2 as MessageDescriptor,
} from '@atlassian/jira-intl/src/v2/types.tsx';
import messages from './messages.tsx';

export type Props = {
	onClick: () => void;
	ariaLabel: MessageDescriptor;
	intl: IntlShape;
};

const AddButton = (props: Props) => {
	const {
		intl: { formatMessage },
		onClick,
		ariaLabel,
	} = props;
	return (
		<Button onClick={onClick} aria-label={formatMessage(ariaLabel)}>
			{formatMessage(messages.add)}
		</Button>
	);
};

export default AddButton;
